import React from 'react';

interface IProps {
  progress: number;
}

export const Progress:React.FC<IProps> = ({ progress }) => (
  <progress className="myinterview-widget__progress" max={100} value={progress || 0} />
);
